import { Area, Point } from '../../../type';
import { getPointBetween } from '../../utils/get-point-between';
import { getPointByRatio } from '../../utils/get-point-by-ratio';
import { getRatioInArea } from '../../utils/get-ratio-in-area';

/**
 * 通用仿射变换函数
 * @param area - 内容区域对象，包含宽度和高度
 * @param point - 待变换的点
 * @param bottomLinePoints - 底线上的点集
 * @param topLinePoints - 顶线上的点集
 * @returns 变换后的点，如果顶线或底线上的点不存在则返回原 point
 */
export function affineTransform(
    area: Area,
    point: Point,
    bottomLinePoints: Point[],
    topLinePoints: Point[],
): Point {
    const ratio = getRatioInArea(point, area);

    // 根据 x 比例获取顶线和底线上的点
    const topPoint = getPointByRatio(topLinePoints, ratio[0]);
    const bottomPoint = getPointByRatio(bottomLinePoints, ratio[0]);

    // 如果顶线或底线上的点不存在，则返回原 point
    if (!topPoint || !bottomPoint) {
        return point;
    }

    // 根据 y 比例计算最终变换点的 x 和 y 坐标
    return getPointBetween(bottomPoint, topPoint, ratio[1]);
}
